// Use the name of the route or page you're trying to reach "If possible"

export type TypePageReturn = string;

export const routeRoot = (): TypePageReturn => "/";

export const routeLogin = (): TypePageReturn => "/login";

export const routeTaxpayers = (): TypePageReturn => "/users";

export const routeUploadFiles = (): TypePageReturn => "/upload-files";

export const routeCertificationsDelivery = (): TypePageReturn => "/certifications-delivery";

export const routeNewTaxpayer = (): TypePageReturn => `${routeTaxpayers()}/new-user`;

export const routeTaxpayer = ({ taxpayerId }: { taxpayerId: number | string }): TypePageReturn => {
  return `${routeTaxpayers()}/${taxpayerId}`;
};

export const routeHome = (): TypePageReturn => routeTaxpayers();

export const routeRetentions = (): TypePageReturn => "/retentions";

export const routeRetentionsInProcess = (): TypePageReturn => `${routeRetentions()}/in-process`;

export const routeHistoricRetentions = (): TypePageReturn => `${routeRetentions()}/historic`;

export const routePartnerCertificates = (): TypePageReturn => "/partner-certificates";

export const routeBulkActions = (): TypePageReturn => "/bulk-actions";

export const routeBulkInvoicing = (): TypePageReturn => "/bulk-invoicing";

export const routeUnifiedIssuing = (): TypePageReturn => "/unified-issuing";

export const routeDigitalStamps = (): TypePageReturn => "/digital-stamps";

export const routeBulkCommonInvoicing = (): TypePageReturn => "/bulk-common-invoicing";

export const routeIssuancesInProgress = (): TypePageReturn => "/issuances-in-progress";